import instance from "@/services/api";

export const shellRoomsAPI = {
  async getShellRooms() {
    return await instance()
      .get("/floor_map/room_purpose/",)
      .then((res) => res?.data);
  },
  async getRoomPurposesFS() {
    return await instance()
      .get("/floor_map/room_purpose_fs/",)
      .then((res) => res?.data);
  },
  async updRoomPurpose(body) {
    return await instance()
      .post("/floor_map/room_purpose_upd/", body)
      .then((res) => res?.data);
  },
  // async updCountCeiling(body) {
  //   return await instance()
  //     .post(`/floor_map/count_ceiling/`, body)
  //     .then((res) => res?.data);
  // },
}